import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Meeting from "@/services/meeting";

export function useDeleteMeeting() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (ids: string | string[]) => {
      const result = await Meeting.deleteMeeting(ids);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to delete meeting(s)");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["meetings"] });
      queryClient.invalidateQueries({ queryKey: ["meetingStats"] });
    },
  });
}
